import React from 'react';
import { ExpansionPanelContent } from '@progress/kendo-react-layout';

const onExpanderKeyDown = (e) => {
  e.stopPropagation();
};

const BaseExpansionPanelContent = (props) => <ExpansionPanelContent tabIndex={0} onKeyDown={onExpanderKeyDown} {...props} />;

export default BaseExpansionPanelContent;
